














import {Component, Vue, Mixins, Prop} from "vue-property-decorator";
import { CreateBlogPostRequest } from "../../services/blog.service";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import SlugInput from "@/components/ui/SlugInput.vue";
import { HashMap } from "../../services/base.service";
import { BlogService } from "../../services/blog.service";
import {slugify} from "../../services/slug.service";

    @Component({
        components: {
            FormGroup,
            SlugInput,
        }
    })
    export default class BlogCreate extends Vue {
        private request!: CreateBlogPostRequest;
        private errors!: HashMap<string>;
        private service!: BlogService;

        private clear() {
            this.errors = {};
            this.request = {
                title: "",
                slug: "",
            }
        }

        private async submit() {
            const res = await this.service.post(this.request);
            this.errors = {};
            if (res.success) {
                this.clear();
                this.$emit('create', res.result);
            } else {
                this.errors = res.error;
            }
            this.$forceUpdate();
        }

        private updateSlug() {
            this.request.slug = slugify(this.request.title);
            this.$forceUpdate();
        }

        private created() {
            this.service = new BlogService();
            this.clear();
        }
    }
